var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[(_vm.showTerms)?_c('TermsAndConditionsWrapper'):_vm._e(),_c('HeaderBar'),_c('main',[_c('router-view')],1),_c('FooterBar')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }